import { SWRConfiguration } from "swr";

import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { DealerProductDetailsRoute } from "../navigation/DealerRoutes";
import { useRouteParams } from "../navigation/useRouteParams";
import { AccessoryPartItem } from "./useSearchAccessoriesByVehicle";

export const useGetAccessoryByPartId = (
  swrOptions: SWRConfiguration<FetcherResult<AccessoryPartItem>> = {}
): ModifiedSWRResponse<FetcherResult<AccessoryPartItem>, AccessoryPartItem> => {
  const route = useRouteParams(DealerProductDetailsRoute);

  const { data, ...result } = useSwrGet<AccessoryPartItem>(
    route
      ? "/retailSiteWebService/parts/accessory/getAccessoryByPartId.php"
      : null,
    route
      ? {
          dealerId: route.dealerId,
          partId: route.partId,
          secondaryPartId: route.secondaryPartId,
          vehicleId: route.vehicleId,
        }
      : {},
    swrOptions
  );

  return { ...result, data: Array.isArray(data) ? undefined : data };
};
